// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["blocks-styles"], () => (__webpack_require__("./sources/ts/blocks.tsx")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["blocks-styles"], () => (__webpack_require__("./sources/scss/blocks.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
